import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class BrokerService {

  constructor(private http: HttpClient) {
  }

  getToken(payload) {
    return this.http.post<any>(urls.BROKER_PANEL_URL + 'auth/login', payload)
      .pipe(
        catchError(errorHandl)
      );
  }

  getCancelReasons(token: any) {
    const queryParams: any = {
      isActive: true,
      limit: 9999
    }

    const params = new HttpParams({fromObject: queryParams});

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<any>(urls.BROKER_PANEL_URL + 'change-reasons/picker', { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }

  getTutorials(token: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<any>(urls.BROKER_PANEL_URL + urls.TUTORIALS, { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }

  getTrips(token: any, queryParams: any) {

    const params = new HttpParams({fromObject: queryParams});

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<any>(urls.BROKER_PANEL_URL + 'trips', { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }

  AcceptMarketTrips(token: any, payload: any) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.post<any>(urls.BROKER_PANEL_URL + 'trips/marketplace/accept', payload, { headers })
      .pipe(
        catchError(errorHandl)
      );
  }

  ReserveMarketTrip(token: any, tripId: any, isReserve: boolean) {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.patch<any>(urls.BROKER_PANEL_URL + `trips/marketplace/reserve/${tripId}`, { isReserve }, { headers })
      .pipe(
        catchError(errorHandl)
      );
  }

  getNotifications(token: any, queryParams?: any) {
    let params = new HttpParams();
    if (queryParams) {
      params = new HttpParams({ fromObject: queryParams });
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    return this.http.get<any>(urls.BROKER_PANEL_URL + urls.NOTIFICATIONS_URL, { params, headers })
      .pipe(
        catchError(errorHandl)
      );
  }
}
